import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CoreModule } from '../../core/core.module';
import { LoaderModule } from '../../shared/directives/loader/loader.module';
import { SharedModule } from '../../shared/shared.module';
import { SalesOrderManagementModule } from '../sales-order-management/sales-order-management.module';
import { CarrierPopupComponent } from './components/carriers-list/carrier-popup/carrier-popup.component';
import { ItemMainInfoComponent } from './components/price-item-detail/item-main-info/item-main-info.component';
import { ItemSizeRestrictionsComponent } from './components/price-item-detail/item-size-restrictions/item-size-restrictions.component';
import {
    ItemTypeActivityPricesComponent
} from './components/price-item-detail/item-type-activity-prices/item-type-activity-prices.component';
import { PriceItemDetailComponent } from './components/price-item-detail/price-item-detail.component';
import { SubCarriersComponent } from './components/price-item-detail/sub-carriers/sub-carriers.component';
import { PriceItemsDialogComponent } from './components/shipment-price-items/price-items-dialog/price-items-dialog.component';
import { ShipmentPriceItemsComponent } from './components/shipment-price-items/shipment-price-items.component';
import { ServiceComponent } from './components/services/service/service.component';
import { ServicesComponent } from './components/services/services.component';
import { SubServiceComponent } from './components/sub-service/sub-service.component';
import { ServicesTabGroupComponent } from './components/shared/tab-group/services-tab-group.component';
import { TablePricingSubCarriersComponent } from './components/shared/table-pricing-sub-carriers/table-pricing-sub-carriers.component';
import { TableShipmentPriceComponent } from './components/shared/table-shipment-price/table-shipment-price.component';
import { TableSizeRestrictionsComponent } from './components/shared/table-size-restrictions/table-size-restrictions.component';
import { TableTypeActivityPricesComponent } from './components/shared/table-type-activity-prices/table-type-activity-prices.component';
import { VendorComponent } from './components/vendors/vendor/vendor.component';
import { VendorsComponent } from './components/vendors/vendors.component';
import { ShipmentPriceItemResolverService } from './services/resolvers/shipment-price-item-resolver.service';
import { SingleServiceResolver } from './services/resolvers/single-service-resolver.service';
import { ShipmentPriceRoutingModule } from './shipment-price-routing.module';
import { CarriersListComponent } from './components/carriers-list/carriers-list.component';
import { FilesUploadedComponent } from './components/price-from-xl/files-uploaded.component';
import { UploadXlsComponent } from './components/upload-xls/upload-xls.component';
import { PriceListFilterComponent } from './components/shared/price-list-filter/price-list-filter.component';
import { LastMileComponent } from './components/price-from-xl/last-mile/last-mile.component';
import { FulfilmentComponent } from './components/price-from-xl/fulfilment/fulfilment.component';

@NgModule({
    declarations: [
        VendorsComponent,
        ServicesComponent,
        SubServiceComponent,
        TablePricingSubCarriersComponent,
        TableShipmentPriceComponent,
        TableSizeRestrictionsComponent,
        TableTypeActivityPricesComponent,
        ServicesTabGroupComponent,
        VendorComponent,
        ServiceComponent,
        CarriersListComponent,
        CarrierPopupComponent,
        ShipmentPriceItemsComponent,
        PriceItemsDialogComponent,
        PriceItemDetailComponent,
        ItemMainInfoComponent,
        ItemSizeRestrictionsComponent,
        SubCarriersComponent,
        ItemTypeActivityPricesComponent,
        FilesUploadedComponent,
        UploadXlsComponent,
        PriceListFilterComponent,
        LastMileComponent,
        FulfilmentComponent,
    ],
    imports: [
        CommonModule,
        ShipmentPriceRoutingModule,
        MatTabsModule,
        MatCardModule,
        CoreModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        SharedModule,
        Ng2TelInputModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSelectInfiniteScrollModule,
        LoaderModule,
        SalesOrderManagementModule,
        FormsModule,
        MatDatepickerModule,
        NgxMatSelectSearchModule,
        MatListModule,
    ],
    providers: [
        SingleServiceResolver,
        ShipmentPriceItemResolverService,
    ],
    exports: [
        TableSizeRestrictionsComponent,
        TableShipmentPriceComponent,
        TableTypeActivityPricesComponent,
    ]
})
export class ShipmentPriceModule {
}
